import { PropsWithChildren, useEffect } from 'react';
import { useAppDispatch } from '../../app/hooks';
import { upadteUpload } from './uploader-slice';
import { RootState, store } from '../../app/store';
import {
  getNextChunk,
  processCompletionActions,
  UploadStatus,
} from './uploader.types';

const processQueue = async (dispatch: any) => {
  //get next chunk to upload and destination
  const uploads = (store.getState() as RootState).uploader.uploads;

  const nextUpload = uploads.find(
    (upload) => upload.status !== 'complete' && upload.status !== 'error'
  );
  if (nextUpload) {
    const { chunk, chunkSize, fileSize, totalChunks, chunkIndex, chunkOffest } =
      getNextChunk(nextUpload);
    //upload chunk
    const body = {
      fileName: nextUpload?.file.name,
      totalChunks,
      fileSize: nextUpload.file.size,
      chunkSize: chunk.size,
      chunkIndex,
      chunkOffest,
    };
    const data = new FormData();
    data.append('file', chunk);
    Object.entries(body).forEach(([key, value]) => {
      data.append(key, value.toString());
    });

    const token = (store.getState() as RootState).auth.token;
    // const responseRaw = await fetch(nextUpload.destination, {
    //   method: 'POST',
    //   body: data,
    //   headers: {
    //     authorization: `Bearer ${token}`,
    //   },
    // });
    const responseRaw = await fetch(nextUpload.destination, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/zip', //'application/octet-stream',
        'Content-Range': `bytes ${chunkOffest}-${
          chunkOffest + chunkSize - 1
        }/${fileSize}`,
        'Content-Length': chunkSize.toString(),
      },
      body: chunk,
    });

    //const responseJson = await responseRaw.json();
    // if (responseJson.complete) {
    if (chunkOffest + chunkSize === fileSize) {
      //if complete, update status
      //dispatch(util.invalidateTags(['Images', 'Archives']));
      dispatch(
        upadteUpload({
          _id: nextUpload._id,
          status: UploadStatus.Complete,
          processedChunks: nextUpload.processedChunks + 1,
        })
      );
      processCompletionActions(nextUpload, dispatch);
    } else {
      //if not complete, update progress
      dispatch(
        upadteUpload({
          _id: nextUpload._id,
          status: UploadStatus.Uploading,
          processedChunks: nextUpload.processedChunks + 1,
        })
      );
    }
  }

  await new Promise((resolve) => setTimeout(resolve, 50));
  processQueue(dispatch);

  //if successful, update progress/runtime.js
  //if error, update error

  // await new Promise((resolve) => setTimeout(resolve, 3000));
  // processQueue(dispatch);
};

export const UploaderQueueProcessor = ({ children }: PropsWithChildren) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    processQueue(dispatch);
  }, []);

  return <>{children}</>;
};
